import React from 'react';
import type { QuickAction } from '../../types/quickActions';

interface QuickActionButtonProps {
  action: QuickAction;
  onClick: () => void;
  theme: 'light' | 'dark';
}

export function QuickActionButton({ action, onClick, theme }: QuickActionButtonProps) {
  const isDark = theme === 'dark';

  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 text-sm rounded-md transition-colors shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.15)] ${
        isDark 
          ? 'bg-gray-700/50 text-gray-200 hover:bg-gray-700'
          : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
      }`}
    >
      {action.text}
    </button>
  );
}